import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Shower = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        d="M15.6726 6.72917C14.3895 5.72917 12.6646 5.54167 11.2132 6.1875L10.8556 5.83333C10.456 5.4375 9.88805 5.33333 9.38321 5.45833L9.13079 5.20833C8.35251 4.4375 7.30077 4 6.18592 4C3.8721 4 2 5.85417 2 8.14583V18.2292C2 18.6458 2.35759 19 2.77829 19C3.19898 19 3.55657 18.6458 3.55657 18.2292V8.14583C3.55657 6.70833 4.73452 5.54167 6.18592 5.54167C6.88007 5.54167 7.53215 5.8125 8.03699 6.29167L8.2894 6.54167C8.16319 7.04167 8.26837 7.60417 8.66803 8L9.02562 8.35417C8.37354 9.79167 8.56286 11.5 9.57253 12.7708C9.7408 13 10.0984 13 10.2877 12.7917L15.6937 7.4375C15.904 7.22917 15.904 6.89583 15.6726 6.72917Z"
        fill="currentColor"
      />
      <path
        d="M14.0112 15.8747L13.6956 15.3538C13.5274 15.0622 13.1277 14.9788 12.8332 15.1455C12.5387 15.3122 12.4546 15.708 12.6229 15.9997L12.9384 16.5205C13.0646 16.708 13.2539 16.8122 13.4643 16.8122C13.5694 16.8122 13.6746 16.7913 13.7798 16.7288C14.0953 16.5413 14.1794 16.1663 14.0112 15.8747Z"
        fill="currentColor"
      />
      <path
        d="M15.0628 17.5833C14.8946 17.2917 14.4949 17.2083 14.2004 17.375C13.9059 17.5417 13.8218 17.9375 13.9901 18.2292L14.3056 18.75C14.4318 18.9375 14.6211 19.0417 14.8315 19.0417C14.9366 19.0417 15.0418 19.0208 15.147 18.9583C15.4415 18.7917 15.5256 18.3958 15.3573 18.1042L15.0628 17.5833Z"
        fill="currentColor"
      />
      <path
        d="M12.644 13.6247L12.3285 13.1038C12.1602 12.8122 11.7605 12.7288 11.466 12.8955C11.1715 13.0622 11.0874 13.458 11.2557 13.7497L11.5712 14.2705C11.6974 14.458 11.8867 14.5622 12.0971 14.5622C12.2023 14.5622 12.3074 14.5413 12.4126 14.4788C12.7281 14.2913 12.8123 13.9163 12.644 13.6247Z"
        fill="currentColor"
      />
      <path
        d="M13.7792 11.5207C13.5479 11.2707 13.1692 11.229 12.8958 11.4582C12.6434 11.6873 12.6013 12.0623 12.8327 12.3332L13.2323 12.7915C13.3585 12.9373 13.5268 12.9998 13.7161 12.9998C13.8634 12.9998 14.0106 12.9582 14.1158 12.854C14.3682 12.6248 14.4103 12.2498 14.1789 11.979L13.7792 11.5207Z"
        fill="currentColor"
      />
      <path
        d="M17.1874 15.5002C16.9561 15.2502 16.5774 15.2085 16.304 15.4377C16.0516 15.6668 16.0095 16.0418 16.2409 16.3127L16.6405 16.771C16.7667 16.9168 16.935 16.9793 17.1243 16.9793C17.2716 16.9793 17.4188 16.9377 17.524 16.8335C17.7764 16.6043 17.8185 16.2293 17.5871 15.9585L17.1874 15.5002Z"
        fill="currentColor"
      />
      <path
        d="M15.4833 13.5207C15.252 13.2707 14.8733 13.229 14.5999 13.4582C14.3475 13.6873 14.3054 14.0623 14.5368 14.3332L14.9364 14.7915C15.0626 14.9373 15.2309 14.9998 15.4202 14.9998C15.5675 14.9998 15.7147 14.9582 15.8199 14.854C16.0723 14.6248 16.1144 14.2498 15.883 13.979L15.4833 13.5207Z"
        fill="currentColor"
      />
      <path
        d="M14.8947 11.2918C15.0209 11.396 15.1471 11.4376 15.2943 11.4376C15.4626 11.4376 15.6519 11.3543 15.7781 11.2293C16.0095 10.9793 15.9674 10.5835 15.715 10.3543L15.2523 9.95845C14.9998 9.75012 14.6002 9.77095 14.3688 10.021C14.1374 10.271 14.1795 10.6668 14.4319 10.896L14.8947 11.2918Z"
        fill="currentColor"
      />
      <path
        d="M17.2291 11.646C16.9767 11.4376 16.577 11.4585 16.3456 11.7085C16.1353 11.9585 16.1773 12.3543 16.4298 12.5835L16.8925 12.9793C17.0187 13.0835 17.1449 13.1251 17.2922 13.1251C17.4605 13.1251 17.6498 13.0418 17.776 12.9168C18.0074 12.6668 17.9653 12.271 17.7129 12.0418L17.2291 11.646Z"
        fill="currentColor"
      />
      <path
        d="M19.2484 13.3335C18.9959 13.1251 18.5963 13.146 18.3649 13.396C18.1335 13.646 18.1756 14.0418 18.428 14.271L18.8908 14.6668C19.017 14.771 19.1432 14.8126 19.2904 14.8126C19.4587 14.8126 19.648 14.7293 19.7742 14.6043C20.0056 14.3543 19.9635 13.9585 19.7111 13.7293L19.2484 13.3335Z"
        fill="currentColor"
      />
      <path
        d="M16.0304 9.43748L16.5563 9.74998C16.6615 9.81248 16.7667 9.83332 16.8718 9.83332C17.0822 9.83332 17.2925 9.72915 17.3977 9.54165C17.566 9.24998 17.4818 8.87498 17.1874 8.68748L16.6615 8.37498C16.367 8.20832 15.9884 8.29165 15.7991 8.58332C15.6308 8.87498 15.736 9.27082 16.0304 9.43748Z"
        fill="currentColor"
      />
      <path
        d="M18.8069 11.1045C18.9121 11.167 19.0172 11.1878 19.1224 11.1878C19.3328 11.1878 19.5431 11.0836 19.6483 10.8961C19.8166 10.6045 19.7324 10.2295 19.4379 10.042L18.9121 9.72948C18.6176 9.56281 18.2389 9.64614 18.0496 9.93781C17.8814 10.2295 17.9655 10.6045 18.26 10.792L18.8069 11.1045Z"
        fill="currentColor"
      />
      <path
        d="M21.7094 11.417L21.1835 11.1045C20.8891 10.9378 20.5104 11.0211 20.3211 11.3128C20.1528 11.6045 20.237 11.9795 20.5315 12.167L21.0573 12.4795C21.1625 12.542 21.2677 12.5628 21.3729 12.5628C21.5832 12.5628 21.7936 12.4586 21.8987 12.2711C22.088 11.9795 22.0039 11.5836 21.7094 11.417Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Shower;
